import axios from "axios";

function webinar() {
    let videoWrapper = document.querySelector('.video-wrapper')
    let form = document.querySelector('.js-webinar-form')
    let formButton = videoWrapper.querySelector('.js-webinar-button')
    let overlay = videoWrapper.querySelector('.overlay')
    let videoEmbedCode = formButton.dataset.src

    if (document.cookie.split(';').some((item) => item.trim().startsWith('is_registered='))) {
        videoWrapper.querySelector('iframe').src = videoEmbedCode
        overlay.style.display = 'none'
    } else {
        if (form) {
            form.addEventListener('submit', e => {
                e.preventDefault()
                let formData = new FormData(form);
                axios
                        .post('users/save-user', formData)
                        .then(response => {
                            videoWrapper.querySelector('iframe').src = videoEmbedCode
                            overlay.classList.toggle('hidden')
                            document.cookie = "is_registered=true"
                        });
            });
        }
    }

}

export default webinar